import { AxiosInstance, AxiosRequestConfig } from "axios";

export const HTTP_REQUEST_STACK_KEY = "topMostError";

export const DEFAULT_STACK_ERROR_TITLE = "[EnhancedAxiosError]";

function enhanceAxiosStack(axiosInstance: AxiosInstance) {
  const originalGetHandler = axiosInstance.get;
  const originalPostHandler = axiosInstance.post;
  const originalPutHandler = axiosInstance.put;
  const originalPatchHandler = axiosInstance.patch;

  axiosInstance.get = function (url, config) {
    const newConfig = {
      ...config,
      [HTTP_REQUEST_STACK_KEY]: new Error(DEFAULT_STACK_ERROR_TITLE),
    } as unknown as AxiosRequestConfig;

    return originalGetHandler(url, newConfig);
  };

  axiosInstance.post = function (url, data, config) {
    const newConfig = {
      ...config,
      [HTTP_REQUEST_STACK_KEY]: new Error(DEFAULT_STACK_ERROR_TITLE),
    } as unknown as AxiosRequestConfig;

    return originalPostHandler(url, data, newConfig);
  };

  axiosInstance.put = function (url, data, config) {
    const newConfig = {
      ...config,
      [HTTP_REQUEST_STACK_KEY]: new Error(DEFAULT_STACK_ERROR_TITLE),
    } as unknown as AxiosRequestConfig;

    return originalPutHandler(url, data, newConfig);
  };

  axiosInstance.patch = function (url, data, config) {
    const newConfig = {
      ...config,
      [HTTP_REQUEST_STACK_KEY]: new Error(DEFAULT_STACK_ERROR_TITLE),
    } as unknown as AxiosRequestConfig;

    return originalPatchHandler(url, data, newConfig);
  };
}

export default enhanceAxiosStack;
